export const queryOptions = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
  retry: false,
};
